'use strict';

var Bacon, R, current, integration$;

R = require('ramda');

Bacon = require('baconjs');

current = new Bacon.Bus();

integration$ = current.toProperty();

integration$.onValue(function () {});

module.exports = {
  initIntegrationFromPermalink: function initIntegrationFromPermalink(permalink) {
    return current.push(permalink);
  },
  current$: integration$
};